import React from 'react'
import { Typography, Box } from '@mui/material'

import { DEFAULT_READ_TIME } from '../../consts'
import useContentType from '../../hooks/useContentType'
import Creator from '../article/creator'
import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ breakpoints, spacing, palette }) => ({
  toolbar: {
    '& > *': {
      paddingRight: 0
    }
  },
  creatorsContainer: {
    flex: '1 1 0',
    overflow: 'hidden'
  },
  creatorsGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(0.5)
  },
  contentGrid: {
    display: 'grid',
    gridTemplateAreas: `
        "breadcrumbs breadcrumbs breadcrumbs"
        "leftPanel content rightPanel"
      `,
    gridTemplateColumns: '1fr 660px 1fr',
    paddingTop: spacing(1),
    marginTop: spacing(2),
    [breakpoints.down('sm')]: {
      gridTemplateColumns: 'initial'
    }
  },
  contentMetadata: {
    marginBottom: spacing(1),
    fontSize: '0.75rem',
    color: '#79848B',
    '& svg': {
      width: 16,
      height: 16,
      verticalAlign: 'sub',
      marginRight: 4
    }
  },
  title: {
    marginBottom: spacing(2)
  },
  subtitle: {
    marginBottom: spacing(2),
    fontSize: '0.9rem'
  },
  header: {
    marginBottom: spacing(1)
  },
  verticalToolbar: ({ width }) => ({
    position: 'fixed',
    top: 114,
    left: 'calc(100vw / 2 - 660px / 2 - 166px)'
  }),
  playlistButton: {
    color: 'white',
    display: 'none',
    [breakpoints.up('lg')]: {
      display: 'initial'
    }
  },
  markAsViewedButton: {
    '&:disabled': {
      backgroundColor: palette.success.shade[10],
      color: palette.success.shade[80]
    }
  },
  relatedArticlesGrid: {
    width: '90%',
    paddingTop: spacing(4),
    height: 0
  }
}))

const Header = ({ content }) => {
  const authorBy = () => <Creator name={author} author />
  const reviewerBy = () => <Creator name={reviewer} />
  const classes = useStyles()
  const {
    readTime = DEFAULT_READ_TIME, // default read time
    author = { name: 'the Mindtools Content Team' },
    reviewer,
    primaryType,
    title,
    subtitle
  } = content

  const { formatIcon, label } = useContentType({ primaryType })

  return (
    <>
      <Box>
        <Typography
          variant='body1'
          className={classes.contentMetadata}
          data-test='article-read-time'
        >
          {formatIcon} {label} &#8226; {readTime} min read
        </Typography>
        <Typography
          variant='h3'
          component='h1'
          className={classes.title}
          data-test='article-title'
        >
          {title}
        </Typography>
        <Typography
          variant='h5'
          component='h2'
          color='textSecondary'
          className={classes.subtitle}
          data-test='article-subtitle'
        >
          {subtitle?.html}
        </Typography>
        <Box>
          <Box>
            {authorBy()}
            {reviewer && reviewerBy()}
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default Header
